module.exports = {
    serverIP:'https://demoapiformoviedb.herokuapp.com',
    //serverIP:'http://192.168.43.243:5000',
    imgServerIP:'https://storage.googleapis.com/demoimgstorage'
}